import { useState } from "react";
import { Trans, useTranslation } from "react-i18next";
import {
  acceptAttribution,
  declineAttribution,
  pendingAttribution,
} from "../../../services/attribution";
import "./attributionConsent.scss";

/**
 * Asks whether DAEX may remember the campaign a visitor came from. Only shown
 * for visits with campaign data (see services/attribution.ts), so regular
 * visitors and app users never see it.
 */
export function AttributionConsent() {
  const { t } = useTranslation("components");
  const [open, setOpen] = useState(() => pendingAttribution() !== null);

  if (!open) return null;

  const decide = (accepted: boolean) => {
    if (accepted) acceptAttribution();
    else declineAttribution();
    setOpen(false);
  };

  return (
    <div
      className="attribution-consent"
      role="dialog"
      aria-live="polite"
      aria-label={t("AttributionConsent.title")}
    >
      <p className="p">
        <Trans
          ns="components"
          i18nKey="AttributionConsent.text"
          components={{
            privacy: (
              <a href="https://web.daex.app/datenschutz/" target="_blank" />
            ),
          }}
        />
      </p>
      <div className="attribution-consent__actions">
        <button className="btn btn-light" onClick={() => decide(false)}>
          {t("AttributionConsent.decline")}
        </button>
        <button className="btn bg_green500" onClick={() => decide(true)}>
          {t("AttributionConsent.accept")}
        </button>
      </div>
    </div>
  );
}
